import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import { useCallback } from 'react'

import { toast } from 'components/ui/toaster'

import { EntityItem, FileItem } from '../../api/ApiTypes'
import useFileAccess from '../documents/useFileAccess'

import useEcpTranslation from './useEcpTranslation'

const useDownloadZip = () => {
  const { t } = useEcpTranslation()
  const { getBinaryContent } = useFileAccess()

  const downloadAsZip = useCallback(
    async (files: EntityItem[]) => {
      const zip = new JSZip()

      if (!files || !files.length) {
        return toast.info({
          title: t('common.error.something_went_wrong'),
          description: t('no_file_to_download')
        })
      }

      for (const file of files) {
        const data = await getBinaryContent(file as FileItem)

        file.type.startsWith('image')
          ? zip.file(file.filename, data, { base64: true })
          : zip.file(file.filename, data, { binary: true })
      }

      await zip
        .generateAsync({ type: 'blob' })
        .then((content) => saveAs(content, 'attachments.zip'))

      return false
    },
    [t, getBinaryContent]
  )

  return { downloadAsZip }
}

export default useDownloadZip
